export default function exportFeedbackToCSV(
  companies,
  feedbackData,
  fileName = "company_feedback_export"
) {
  const rows = [];

  const getLeadTypeLabel = (type) => {
    if (type === "ACCEPT") return "Lead";
    if (type === "NOT ACCEPT") return "Discard";
    return "Unsure";
  };

  // HEADER ROW
  rows.push([
    "Organization Name",
    "Original Lead Type",
    "Corrected Lead Type",
    "User Feedback",
    "Last Updated",
    "Justification",        // <-- UPDATED HERE
    "Industries",
    "Bucket Industries",
    "Country",
    "Founded",
    "Employees",
    "Investment Stage",
    "Last Funding Date",
    "Crunchbase Rank",
    "Website",
    "Crunchbase URL"
  ].join(","));

  // ESCAPE QUOTES FOR CSV SAFETY
  const esc = (val) => {
    if (val === undefined || val === null) return "";
    return `"${String(val).replace(/"/g, '""')}"`;
  };

  companies.forEach((c) => {
    // Use stable ID
    const fb = feedbackData[c.id] || {};

    const comment = fb.comment || "";
    const originalType = c["Original Lead Type"] || c["Lead Type"];
    const correctedType = fb.correctedType || c["Lead Type"];
    const timestamp = fb.timestamp
      ? new Date(fb.timestamp).toLocaleString()
      : "";

    const row = [
      esc(c["Organization Name"]),
      esc(getLeadTypeLabel(originalType)),
      esc(getLeadTypeLabel(correctedType)),
      esc(comment),
      esc(timestamp),
      esc(c["Reasoning"] || ""),          // <-- REASONING VALUE (unchanged)
      esc(c["Industries"] || ""),
      esc((c.BucketIndustries || []).join(";")),
      esc(c["Headquarters Location"]),
      esc(c["Founded"]),
      esc(c["Employees"]),
      esc(c["Investment Stage"]),
      esc(c["Last Funding Date"]),
      esc(c["Crunchbase Rank"]),
      esc(c["Website"]),
      esc(c["Crunchbase"])
    ];

    rows.push(row.join(","));
  });

  const csv = rows.join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const safeFileName = String(fileName || "company_feedback_export")
    .trim()
    .replace(/[^a-zA-Z0-9-_ ]/g, "")
    .replace(/\s+/g, "_");

  const a = document.createElement("a");
  a.href = url;
  a.download = `${safeFileName || "company_feedback_export"}.csv`;
  a.click();
}
